export default {
  serverUrl: 'https://api.voopty.com/api',
  imgUrl: 'https://voopty.com/',
  oldWebAppUrl: 'https://coach.voopty.com',
  webAppUrl: 'https://voopty.com',
  recaptchaSiteKey: '6LcS4hYTAAAAAA4aq_fqxHrU47fqsZrLb4mAoOSy',
  rootUrl: {
    en_US: 'https://voopty.com',
    ru_UA: 'https://voopty.com.ua',
    uk_UA: 'https://voopty.com.ua',
  },
  bizUrl: 'https://biz.voopty.com',
  DEMO_LINK: 'https://www.voopty.com/client/5d6559789c8cbd00064920b4/69f9e477b4d6e10124bb2b6a',
  googleOAuthClientId: '294739332141-m19duo0itqvgtd7uvp5b0s2eccjhp1gj.apps.googleusercontent.com',
};
